export * from './objekt-arts.service';
export * from './objekt-arts.service.module';